import styled from 'styled-components';
import {
  BORDER_RADIUS,
  FONT_WEIGHT_BOLD,
  DANGER_COLOR,
  GRAY_LIGHTER,
  FONT_SIZE_6,
  GRAY_LIGHTER_2,
  GRAY_DARKER,
  FONT_SIZE_7,
  INFO_COLOR,
} from '../../styles/variables';
import { flexPosition, fontStyle } from '../../styles/mixins';

export const Container = styled.div`
  width: ${props => props.width || '100%'};
`;

export const ImageContainer = styled.div`
  position: relative;
  background-color: ${props => (props.bgColor ? GRAY_LIGHTER_2 : '#FFF')};
  width: ${props => props.width || '280px'};
  height: ${props => props.height || '110px'};
  border-radius: ${BORDER_RADIUS};
`;

export const LabelContainer = styled.label`
  position: absolute;
  background: #f9f9f9;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  ${flexPosition({ align: 'center', justify: 'center' })}
  z-index: 2;
  cursor: pointer;
`;

export const InputFile = styled.input`
  opacity: 0;
  position: absolute;
  z-index: -1;
`;

export const CloseIcon = styled.button`
  border: none;
  background-color: ${DANGER_COLOR};
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 100px;
  position: absolute;
  top: -15px;
  right: -10px;
  z-index: 2;
`;

export const Rules = styled.div`
  width: 100%;
  height: 50px;
  ${flexPosition({ align: 'center' })}
  margin-top: 15px;
  padding: 0px 5px;
`;

export const RuleText = styled.p`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_7, FONT_WEIGHT_BOLD)}
  margin: 0;
`;

export const RuleSeparator = styled.span`
  display: block;
  border-left: 1px solid ${GRAY_LIGHTER};
  height: 100%;
  margin: 0 10px 0px 5px;
`;

export const LinkButton = styled.button`
  cursor: pointer;
  background-color: transparent;
  border: none;
  ${fontStyle(INFO_COLOR, FONT_SIZE_6, FONT_WEIGHT_BOLD)}
  padding: 10px;
  width: 100%;
  text-align: center;
  margin-top: 10px;
`;



// WEBPACK FOOTER //
// ./src/components/ImageUpload/style.js